import React from 'react';
import {paths} from '../../../common/dictionaries/urls';
import {Link} from 'react-router-dom';
import {Icon} from 'semantic-ui-react';

export const getColumns = () => {
  return [
    {
      'Header': 'DETALLE',
      'width': 65,
      'Filter': () => {
        return null;
      },
      'Cell': ({row}) => {
        return (
          <div style={{'textAlign': 'center'}}>
            <Link to={{
              'pathname': paths.DispatchOrdersEdit.replace(':code', row.original.orderId),
            }}> <Icon name='eye' className='input icon toyota-primary' size='large' />
            </Link>
          </div>
        );
      },
    },
    {
      'Header': 'Nº ORDEN',
      'accessor': 'orderId',
    },
    {
      'Header': 'ESTADO',
      'accessor': 'statusDescription',
    },
    {
      'Header': 'FECHA CREACIÓN',
      'accessor': 'addDate',
      'Cell': ({row}) => {
        return <div style={{'textAlign': 'center'}}>{row.original.addDate}</div>;
      },
    },
    {
      'Header': 'USUARIO',
      'accessor': 'addUser',
    },
    {
      'Header': <div style={{'wordBreak': 'break-word', 'whiteSpace': 'break-spaces'}}>FACTURACIÓN ANTICIPADA</div>,
      'accessor': 'anticipatedInvoice',
      'Cell': (row) => {
        return <div style={{'textAlign': 'center'}}>{row.value}</div>;
      },
    },
    {
      'Header': 'TIPO FACTURACIÓN',
      'accessor': 'typeDescription',
    },
    {
      'Header': 'FACTURAR A',
      'accessor': 'dealerName',
    },
    {
      'Header': 'FECHA MODIFICADO',
      'accessor': 'updateDate',
      'Cell': ({row}) => {
        return <div style={{'textAlign': 'center'}}>{row.original.updateDate}</div>;
      },
    },
    {
      'Header': 'MODIFICADO POR',
      'accessor': 'updateUser',
    },
  ];
};
